import { get, post } from '@/utils/fetch'

export function getAppList(data) {
  return get({
    url: 'manage/sys/app/getAppListByLoginName',
    data
  })
}

export function updateUserInfo(data) {
  return post({
    url: 'manage/sys/user/updateUserInfo',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/getApp.js